import {
  Box,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Typography,
} from "@mui/material";
import ArrowIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import { ReactNode } from "react";
import {
  hiringIcon,
  performanceManagementIcon,
  cultureValuesIcon,
  leadershipIcon,
  sltExecIcon,
  flexibleWorkIcon,
  parentalLeaveIcon,
  transparentPayIcon,
  policiesIcon,
  respectWorkIcon,
} from "../../assets/icons";
import { IStandards } from "../../types/standard";
import { useNavigate } from "react-router";
import { Paths } from "../../types/app";

type StandardsCardProps = {
  standard: IStandards;
  ButtonComponent: ReactNode;
};

export const mapIcons = {
  hiring: hiringIcon,
  performanceManagement: performanceManagementIcon,
  cultureValues: cultureValuesIcon,
  leadership: leadershipIcon,
  sltExec: sltExecIcon,
  flexibleWork: flexibleWorkIcon,
  parentalLeave: parentalLeaveIcon,
  transparentPay: transparentPayIcon,
  policies: policiesIcon,
  respectWork: respectWorkIcon,
};

export const StandardsCardHomepage = ({
  standard,
  ButtonComponent,
}: StandardsCardProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Card className="standardCard" sx={{ padding: "20px" }}>
      <CardContent sx={{ padding: 0 }}>
        <Box
          component="img"
          alt={standard.title + " icon"}
          src={mapIcons[standard.iconPath]}
        />
        <Typography variant="body2">
          {standard.title}
          <IconButton
            onClick={() =>
              navigate(Paths.ACTION_PLAN_HOME_PAGE + "/" + standard.id)
            }
            sx={{ padding: 0, paddingLeft: "3px" }}
          >
            <ArrowIcon />
          </IconButton>
        </Typography>
      </CardContent>
      <CardActions sx={{ padding: 0 }}>{ButtonComponent}</CardActions>
    </Card>
  );
};

export const StandardsCard = ({
  standard,
  ButtonComponent,
}: StandardsCardProps): React.ReactElement => {
  return (
    <Card className="standardCard">
      <CardContent sx={{ padding: 0 }}>
        <Box
          component="img"
          alt={standard.title + " icon"}
          src={mapIcons[standard.iconPath]}
        />
        <Typography variant="h6" className="ap-home-page-heading">
          {standard.title}
        </Typography>
      </CardContent>
      <CardActions sx={{ padding: 0 }}>{ButtonComponent}</CardActions>
    </Card>
  );
};
